import type { RoleI, RoleWithPermissionsI, RoleCreateI, RoleUpdateI } from 'types';
import { BaseApi } from './base-api';
import { fetchData } from 'Utils/fetch-data';

class RolesApi extends BaseApi<RoleI> {
  /**
   * `GET /api/roles`
   * Obtener todos los roles disponibles en el sistema.
   */
  async readAll() {
    const response = await fetchData<RoleI[]>(`${this.endpoint}`, {
      method: 'GET',
    });
    return response;
  }

  /**
   * `GET /roles/:id/permissions`
   * Obtiene los permisos del sistema indicando cuáles tiene asignado o no el rol.
   */
  async readPermissions(id: string) {
    const response = await fetchData<RoleWithPermissionsI>(`${this.endpoint}/${id}/permissions`, {
      method: 'GET',
    });
    return response;
  }

  /**
   * `POST /roles`
   * Crea un nuevo rol con nombre, estatus y permisos asignados.
   * @param payload Información para el nuevo rol.
   * @returns Respuesta de la consulta.
   */
  async createRole(payload: any) {
    const response = await fetchData<{ success: boolean }>(`${this.endpoint}`, {
      method: 'POST',
      data: payload,
    });
    return response;
  }

  /**
   * `PATCH /roles/:id`
   * Actualiza un rol existente y sus permisos.
   */
  async patch(id: string, payload: any) {
    const response = await fetchData<{ success: boolean }>(`${this.endpoint}/${id}`, {
      method: 'PATCH',
      data: payload,
    });
    return response;
  }
}

const rolesApi = new RolesApi('/roles');

export default rolesApi;
